/** @jsxImportSource ./simboluri-jsx */
// Icoanele shell-ului nou — copiate 1:1 din planșele mock-ui/design (stroke
// 1.7, viewBox 20). Un singur loc, ca railul și paginile să deseneze identic.

function I({ d, size = 18 }: { d: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {d.split("|").map((p, i) => (
        <path key={i} d={p} />
      ))}
    </svg>
  );
}

export const IcStudio = ({ size = 18 }: { size?: number }) => (
  <I size={size} d="M10 2.5 16.5 6v8L10 17.5 3.5 14V6L10 2.5z|M10 10l6.5-4M10 10 3.5 6M10 10v7.5" />
);
// Soluțiile = RAMURI, nu un grid de patru pătrate:
// arborele căutării se citește ca un graf de branch-uri, ca în git.
export const IcBranch = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5.5" cy="4.5" r="2" />
    <circle cx="5.5" cy="15.5" r="2" />
    <circle cx="14.5" cy="9" r="2" />
    <path d="M5.5 6.5v7" />
    <path d="M12.5 9H9.5a4 4 0 00-4 4" />
  </svg>
);
export const IcVerificari = ({ size = 18 }: { size?: number }) => (
  <I size={size} d="M4 10.5l4 4L16.5 6" />
);
export const IcDosar = ({ size = 18 }: { size?: number }) => (
  <I size={size} d="M5 2.5h7l3.5 3.5v11.5H5V2.5z|M12 2.5V6h3.5" />
);
export const IcPipeline = ({ size = 18 }: { size?: number }) => (
  <I size={size} d="M11 2 4 11.5h5L8 18l7-9.5h-5L11 2z" />
);
// Setări = ROATĂ DINȚATĂ. Varianta de dinainte (cerc cu raze) arăta ca un
// soare, nu ca niște setări.
export const IcPreferinte = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="10" cy="10" r="2.6" />
    {/* conturul dințat: opt dinți, ca la o roată de reglaj */}
    <path d="M10 1.9l1.05 1.42a7.2 7.2 0 011.6.66L14.4 3.4l1.63 1.63-.58 1.75a7.2 7.2 0 01.66 1.6L17.53 9.4v2.3l-1.42 1.05a7.2 7.2 0 01-.66 1.6l.58 1.75-1.63 1.63-1.75-.58a7.2 7.2 0 01-1.6.66L10 18.1l-1.05-1.42a7.2 7.2 0 01-1.6-.66l-1.75.58L3.97 15l.58-1.75a7.2 7.2 0 01-.66-1.6L2.47 11.7V9.4l1.42-1.05a7.2 7.2 0 01.66-1.6L3.97 5l1.63-1.63 1.75.58a7.2 7.2 0 011.6-.66L10 1.9z" />
  </svg>
);
export const IcStea = ({ size = 11 }: { size?: number }) => (
  <I size={size} d="M10 2.8l2.2 4.5 4.9.7-3.6 3.4.9 4.9L10 14l-4.4 2.3.9-4.9L2.9 8l4.9-.7L10 2.8z" />
);
export const IcBucla = ({ size = 15 }: { size?: number }) => (
  <I size={size} d="M4 10a6 6 0 116 6|M4 10H2M4 10l1.5 2M10 6.5V10l2.5 1.5" />
);
